import { OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { environment } from 'src/environments/environment';
import * as LoadMessageActions from '../../../messagingV3/legacy/actions/load-message.actions';
import * as fromSettings from '../../../settings/reducers';
import * as DashboardActions from '../../actions/dashboard.actions';
import * as fromDashboard from '../../reducers';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(_store, _navigationService) {
        var _this = this;
        this._store = _store;
        this._navigationService = _navigationService;
        this._subs = new Subscription();
        this.displayedColumnList = ['name', 'type', 'drug', 'dueDate'];
        // Setup Observables
        this.tableText$ = this._store.pipe(select(fromSettings.getSectionTranslations('UpcomingDrugs')));
        this.nonTimedTriggerTableText$ = this._store.pipe(select(fromSettings.getSectionTranslations('NonTimedTriggerDrugs')));
        this.medication$ = this._store.pipe(select(fromDashboard.getDashboardMedications), map(function (meds) {
            return meds.Medication.filter(function (med) { return med.StatusId === 2; }).map(function (med) { return ({
                id: med.PatientId,
                name: (med.FirstName + " " + med.LastName + " (" + med.PatientIdentifier + ")").toUpperCase(),
                type: med.Type,
                drug: med.DrugName,
                dosage: med.DrugDosage,
                status: med.Status,
                statusId: med.StatusId,
                dueDate: med.DueDate
            }); });
        }));
        this.nonTimedTriggerMedication$ = this._store.pipe(select(fromDashboard.getDashboardNonTimedTriggerMedications), map(function (meds) {
            return meds.Medication.filter(function (med) { return true; }).map(function (med) { return ({
                id: med.PatientId,
                name: (med.FirstName + " " + med.LastName + " (" + med.PatientIdentifier + ")").toUpperCase(),
                type: med.Type,
                drug: med.DrugName,
                dosage: med.DrugDosage,
                status: med.Status,
                statusId: med.StatusId,
                dueDate: med.DueDate
            }); });
        }));
        // capture text entries to feed into components
        this._subs.add(this.tableText$.subscribe(function (val) { return (_this.tableText = val); }));
        this._subs.add(this.nonTimedTriggerTableText$.subscribe(function (val) { return (_this.nonTimedTriggerTableText = val); }));
    }
    DashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        // reload dashboard straight away and then
        // every 30 seconds
        this.load();
        this.interval = setInterval(function () {
            _this.load();
        }, 1000 * environment.dashboardRefreshIntervalSeconds);
    };
    DashboardComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.interval);
        this._subs.unsubscribe();
    };
    DashboardComponent.prototype.gotoPatient = function (number) {
        this._navigationService.navigate(["/patients/" + number]);
    };
    DashboardComponent.prototype.load = function () {
        this._store.dispatch(new DashboardActions.RefreshClinicDashboard());
        this._store.dispatch(new LoadMessageActions.LoadMessagingSummary());
    };
    return DashboardComponent;
}());
export { DashboardComponent };
